<template>
  <div>
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">机侧题库</Breadcrumb-item>
        <Breadcrumb-item>蓝图</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search mex-search">
      <Form :show-message="false" label-position="top">
        <Row :gutter="16">
          <i-col :span="12">
            <Form-item label="考试类型">
              <Select v-model="queryParam.examType" clearable placeholder="请选择考试类型">
                <Option value="PLACEMENT">入门测</Option>
                <Option value="SUMMATIVE">阶段测</Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :span="12">
            <Form-item label="状态">
              <Select v-model="queryParam.status" clearable placeholder="请选择状态">
                <Option value="ONLINE">已上线</Option>
                <Option value="OFFLINE">已下线</Option>
              </Select>
            </Form-item>
          </i-col>
        </Row>
        <div class="mex-search-actions">
          <Button type="primary" @click="search">搜索</Button>
          <Button type="success" @click="openCreate">新建</Button>
        </div>
      </Form>
    </div>
    <List ref="list" style="margin-top: 10px" :tableColumns="tableColumns" listUrl="/mex/blueprints/list"
          :params="queryParam" :onLoading="onLoading" :reload="reload"></List>
    <Modal v-model="editVisible" :title="form.id ? '编辑蓝图' : '新建蓝图'" width="980">
      <div style="max-height:70vh;overflow-y:auto;padding-right:8px">
        <Form :label-width="110">
          <Row :gutter="12">
            <i-col :span="8">
              <Form-item label="考试类型">
                <Select v-model="form.examType" transfer @on-change="onExamTypeChange">
                  <Option value="PLACEMENT">入门测</Option>
                  <Option value="SUMMATIVE">阶段测</Option>
                </Select>
              </Form-item>
            </i-col>
            <i-col :span="8">
              <Form-item :label="form.examType === 'SUMMATIVE' ? '技能站点' : '档位'">
                <Select v-model="form.segment" transfer>
                  <Option v-for="s in segmentOptions(form.examType, form.segment)" :value="s.value" :key="s.value">{{s.label}}</Option>
                </Select>
              </Form-item>
            </i-col>
            <i-col :span="8">
              <Form-item label="版本">
                <Input v-model="form.versionNo" placeholder="v1.0"></Input>
              </Form-item>
            </i-col>
          </Row>
          <Row :gutter="12">
            <i-col :span="8">
              <Form-item label="题量上限">
                <Input-number v-model="form.itemLimit" :min="0" :max="200" placeholder="0 表示沿用默认" style="width:100%"></Input-number>
              </Form-item>
            </i-col>
            <i-col :span="8">
              <Form-item label="限时（秒）">
                <Input-number v-model="form.durationSec" :min="0" :max="7200" placeholder="0 表示沿用默认" style="width:100%"></Input-number>
              </Form-item>
            </i-col>
          </Row>
          <Form-item label="状态">
            <Select v-model="form.status" transfer>
              <Option value="ONLINE">已上线</Option>
              <Option value="OFFLINE">已下线</Option>
            </Select>
          </Form-item>
          <Form-item label="组卷槽位">
            <p class="mex-slot-hint">每一行是一类题：从哪个库抽、什么技能和题型、出几道、每道多少分。入门测不能加写作。</p>
            <div v-for="(slot, idx) in slots" :key="idx" class="mex-slot-card">
              <div class="mex-slot-head">
                <span>第 {{idx + 1}} 类题</span>
                <Button size="small" type="text" @click="removeSlot(idx)">删除</Button>
              </div>
              <Form :show-message="false" label-position="top">
                <Row :gutter="12">
                  <i-col :span="8">
                    <Form-item label="题库">
                      <Select v-model="slot.bank" transfer @on-change="onBankChange(slot)">
                        <Option value="COMP">综合库（听/读/写）</Option>
                        <Option value="SPEAK">口语库</Option>
                      </Select>
                    </Form-item>
                  </i-col>
                  <i-col :span="8">
                    <Form-item label="技能">
                      <Select v-model="slot.skill" transfer @on-change="onSkillChange(slot)">
                        <Option value="Listening">听力 Listening</Option>
                        <Option value="Speaking">口语 Speaking</Option>
                        <Option value="Reading">阅读 Reading</Option>
                        <Option v-if="form.examType !== 'PLACEMENT'" value="Writing">写作 Writing</Option>
                      </Select>
                    </Form-item>
                  </i-col>
                  <i-col :span="8">
                    <Form-item label="题型">
                      <Select v-model="slot.questionType" filterable transfer placeholder="与题库列表题型一致">
                        <Option v-for="t in questionTypesOf(slot.skill, slot.questionType)" :value="t.value" :key="t.value">{{t.label}}</Option>
                      </Select>
                    </Form-item>
                  </i-col>
                  <i-col :span="8">
                    <Form-item label="出几道">
                      <Input-number v-model="slot.count" :min="1" :max="20" placeholder="如 4" style="width:100%"></Input-number>
                    </Form-item>
                  </i-col>
                  <i-col :span="8">
                    <Form-item label="每道分值">
                      <Input-number v-model="slot.scoreEach" :min="0" :max="20" :step="1" placeholder="如 1" style="width:100%"></Input-number>
                    </Form-item>
                  </i-col>
                </Row>
              </Form>
            </div>
            <Button type="dashed" long @click="addSlot">添加一类题</Button>
          </Form-item>
          <Form-item label="模块权重">
            <p class="mex-slot-hint">报告合成总分时按模块占比加权，不参与抽题。入门测只有听/说/读，建议合计 100。</p>
            <div class="mex-slot-card">
              <Form :show-message="false" label-position="top">
                <Row :gutter="12">
                  <i-col :span="6" v-for="w in weights" :key="w.skill">
                    <Form-item :label="skillLabel(w.skill)">
                      <Input-number v-model="w.weight" :min="0" :max="100" placeholder="百分数，如 40" style="width:100%"></Input-number>
                    </Form-item>
                  </i-col>
                </Row>
              </Form>
              <p class="mex-slot-hint">当前合计 {{weightSum}}</p>
            </div>
          </Form-item>
        </Form>
      </div>
      <div slot="footer">
        <Button @click="editVisible = false">取消</Button>
        <Button type="primary" @click="save">保存</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { questionTypeLabel } from './mex-question-type'

export default {
  name: 'MexBlueprintList',
  data () {
    return {
      searchLoading: false,
      reload: 0,
      editVisible: false,
      queryParam: {},
      form: {},
      slots: [],
      weights: [],
      typeMap: {
        Listening: [],
        Speaking: [],
        Reading: [],
        Writing: []
      },
      tableColumns: [
        { title: 'ID', key: 'id', width: 80, ellipsis: true },
        { title: '考试类型', key: 'examType', width: 120, ellipsis: true, render: (h, params) => h('span', this.examTypeLabel(params.row.examType)) },
        { title: '学段', key: 'segment', width: 140, ellipsis: true, render: (h, params) => h('span', this.segmentLabel(params.row.examType, params.row.segment)) },
        { title: '版本号', key: 'versionNo', width: 100, ellipsis: true },
        { title: '题量上限', key: 'itemLimit', width: 100, ellipsis: true },
        { title: '限时（秒）', key: 'durationSec', width: 110, ellipsis: true },
        { title: '状态', key: 'status', width: 100, ellipsis: true, render: (h, params) => h('span', this.statusLabel(params.row.status)) },
        { title: '组卷槽位', key: 'slotsJson', width: 420, ellipsis: true, render: (h, params) => h('span', this.slotSummary(params.row.slotsJson)) },
        {
          title: '操作',
          key: 'action',
          width: 240,
          render: (h, params) => {
            return h('div', { style: { whiteSpace: 'nowrap' } }, [
              h('Button', {
                props: { type: 'primary', size: 'small' },
                style: { marginRight: '6px' },
                on: { click: () => this.openEdit(params.row) }
              }, '编辑'),
              h('Button', {
                props: { type: 'primary', size: 'small' },
                style: { marginRight: '6px' },
                on: { click: () => this.changeStatus(params.row.id, 'online') }
              }, '上线'),
              h('Button', {
                props: { size: 'small' },
                on: { click: () => this.changeStatus(params.row.id, 'offline') }
              }, '下线')
            ])
          }
        }
      ]
    }
  },
  computed: {
    weightSum () {
      let n = 0
      this.weights.forEach(item => {
        n += Number(item.weight) || 0
      })
      return n
    }
  },
  created () {
    this.loadAllQuestionTypes()
  },
  methods: {
    onLoading (loading) {
      this.searchLoading = loading
    },
    examTypeLabel (code) {
      if (code === 'PLACEMENT') return '入门测'
      if (code === 'SUMMATIVE') return '阶段测'
      return code || ''
    },
    segmentOptions (examType, current) {
      let list
      if (examType === 'SUMMATIVE') {
        // 阶段测按级别段选蓝图，学生端用 courseLevel 匹配这四个段。
        // 下面四个技能站点是分段化之前的旧取值，留着让老数据还能显示和编辑。
        list = [
          { value: 'L1-L2', label: 'L1-L2' },
          { value: 'L3-L4', label: 'L3-L4' },
          { value: 'L5-L6', label: 'L5-L6' },
          { value: 'L7-L8', label: 'L7-L8' },
          { value: 'LISTENING', label: '听力（旧）' },
          { value: 'SPEAKING', label: '口语（旧）' },
          { value: 'READING', label: '阅读（旧）' },
          { value: 'WRITING', label: '写作（旧）' }
        ]
      } else {
        list = [
          { value: 'LOW', label: '低段 L1-L2' },
          { value: 'MID', label: '中段 L3-L5' },
          { value: 'HIGH', label: '高段 L6-L7' }
        ]
      }
      if (current) {
        let hit = false
        for (let i = 0; i < list.length; i++) {
          if (list[i].value === current) {
            hit = true
            break
          }
        }
        if (!hit) {
          list.push({ value: current, label: current + '（已有）' })
        }
      }
      return list
    },
    segmentLabel (examType, code) {
      if (!code) return ''
      let list = this.segmentOptions(examType, code)
      for (let i = 0; i < list.length; i++) {
        if (list[i].value === code) return list[i].label
      }
      return code
    },
    onExamTypeChange () {
      let opts = this.segmentOptions(this.form.examType)
      let hit = false
      for (let i = 0; i < opts.length; i++) {
        if (opts[i].value === this.form.segment) {
          hit = true
          break
        }
      }
      if (!hit) {
        this.form.segment = this.form.examType === 'SUMMATIVE' ? 'L1-L2' : 'MID'
      }
      this.syncWeightsToExamType()
    },
    statusLabel (code) {
      if (code === 'ONLINE') return '已上线'
      if (code === 'OFFLINE') return '已下线'
      return code || ''
    },
    skillLabel (code) {
      if (code === 'Listening') return '听力'
      if (code === 'Speaking') return '口语'
      if (code === 'Reading') return '阅读'
      if (code === 'Writing') return '写作'
      return code || ''
    },
    toTypeOptions (list, skill) {
      let rows = list || []
      return rows.filter(t => t).map(t => {
        return { value: t, label: questionTypeLabel(t, skill) }
      })
    },
    loadAllQuestionTypes () {
      let skills = ['Listening', 'Reading', 'Writing']
      skills.forEach(skill => {
        this.$http.post('/mex/comp/questions/types', { skill: skill }).then(res => {
          if (res.status === 'ok') {
            this.$set(this.typeMap, skill, this.toTypeOptions(res.data, skill))
          }
        })
      })
      this.$http.post('/mex/speak/questions/types').then(res => {
        if (res.status === 'ok') {
          this.$set(this.typeMap, 'Speaking', this.toTypeOptions(res.data, 'Speaking'))
        }
      })
    },
    firstTypeOf (skill) {
      let list = this.typeMap[skill] || []
      return list[0] ? list[0].value : ''
    },
    questionTypesOf (skill, current) {
      let list = (this.typeMap[skill] || []).slice()
      if (current) {
        let hit = false
        for (let i = 0; i < list.length; i++) {
          if (list[i].value === current) {
            hit = true
            break
          }
        }
        if (!hit) {
          list.push({ value: current, label: questionTypeLabel(current, skill) })
        }
      }
      return list
    },
    emptySlot () {
      return {
        bank: 'COMP',
        skill: 'Listening',
        questionType: this.firstTypeOf('Listening'),
        count: 1,
        scoreEach: 1
      }
    },
    emptyForm () {
      return {
        examType: 'PLACEMENT',
        segment: 'MID',
        versionNo: 'v1.0',
        itemLimit: 0,
        durationSec: 0,
        status: 'ONLINE'
      }
    },
    defaultWeights (examType) {
      if (examType === 'SUMMATIVE') {
        return [
          { skill: 'Listening', weight: 25 },
          { skill: 'Speaking', weight: 25 },
          { skill: 'Reading', weight: 25 },
          { skill: 'Writing', weight: 25 }
        ]
      }
      return [
        { skill: 'Listening', weight: 40 },
        { skill: 'Speaking', weight: 30 },
        { skill: 'Reading', weight: 30 }
      ]
    },
    parseWeights (raw, examType) {
      let defaults = this.defaultWeights(examType)
      if (!raw) return defaults
      try {
        let obj = typeof raw === 'string' ? JSON.parse(raw) : raw
        if (!obj || typeof obj !== 'object' || obj.length != null) {
          this.$Message.warning('原模块权重无法解析，已套用默认值')
          return defaults
        }
        let used = {}
        let list = defaults.map(item => {
          used[item.skill] = true
          let val = obj[item.skill]
          return {
            skill: item.skill,
            weight: val == null ? item.weight : Number(val)
          }
        })
        Object.keys(obj).forEach(key => {
          if (!used[key]) {
            list.push({ skill: key, weight: Number(obj[key]) })
          }
        })
        return list
      } catch (e) {
        this.$Message.warning('原模块权重无法解析，已套用默认值')
        return defaults
      }
    },
    stringifyWeights () {
      let obj = {}
      this.weights.forEach(item => {
        if (item.skill) {
          obj[item.skill] = Number(item.weight) || 0
        }
      })
      return JSON.stringify(obj)
    },
    syncWeightsToExamType () {
      let prev = {}
      this.weights.forEach(item => {
        prev[item.skill] = item.weight
      })
      this.weights = this.defaultWeights(this.form.examType).map(item => {
        return {
          skill: item.skill,
          weight: prev[item.skill] == null ? item.weight : prev[item.skill]
        }
      })
    },
    parseSlots (raw) {
      if (!raw) return [this.emptySlot()]
      try {
        let arr = typeof raw === 'string' ? JSON.parse(raw) : raw
        if (!arr || !arr.length) return [this.emptySlot()]
        return arr.map(item => {
          let skill = item.skill || 'Listening'
          let bank = item.bank || (skill === 'Speaking' ? 'SPEAK' : 'COMP')
          let types = this.questionTypesOf(skill)
          let questionType = item.questionType || (types[0] && types[0].value) || ''
          return {
            bank: bank,
            skill: skill,
            questionType: questionType,
            count: item.count == null ? 1 : Number(item.count),
            scoreEach: item.scoreEach == null ? 1 : Number(item.scoreEach)
          }
        })
      } catch (e) {
        this.$Message.warning('原槽位数据无法解析，已重置为一行')
        return [this.emptySlot()]
      }
    },
    slotSummary (raw) {
      try {
        let arr = typeof raw === 'string' ? JSON.parse(raw) : raw
        if (!arr || !arr.length) return ''
        return arr.map(item => {
          return this.skillLabel(item.skill) + ' ' + (item.count || 0) + '道'
        }).join(' / ')
      } catch (e) {
        return raw || ''
      }
    },
    addSlot () {
      this.slots.push(this.emptySlot())
    },
    removeSlot (idx) {
      if (this.slots.length <= 1) {
        this.$Message.warning('至少保留一类题')
        return
      }
      this.slots.splice(idx, 1)
    },
    onBankChange (slot) {
      if (slot.bank === 'SPEAK') {
        slot.skill = 'Speaking'
      } else if (slot.skill === 'Speaking') {
        slot.skill = 'Listening'
      }
      this.onSkillChange(slot)
    },
    onSkillChange (slot) {
      if (slot.skill === 'Speaking') {
        slot.bank = 'SPEAK'
      } else {
        slot.bank = 'COMP'
      }
      let types = this.questionTypesOf(slot.skill)
      let hit = false
      for (let i = 0; i < types.length; i++) {
        if (types[i].value === slot.questionType) {
          hit = true
          break
        }
      }
      if (!hit && types.length) {
        slot.questionType = types[0].value
      }
    },
    search () {
      this.reload = Date.now()
      this.$nextTick(() => this.$refs.list && this.$refs.list.search())
    },
    openCreate () {
      this.loadAllQuestionTypes()
      this.form = this.emptyForm()
      this.slots = [this.emptySlot()]
      this.weights = this.defaultWeights(this.form.examType)
      this.editVisible = true
    },
    openEdit (row) {
      this.loadAllQuestionTypes()
      this.form = {
        id: row.id,
        examType: row.examType,
        segment: row.segment,
        versionNo: row.versionNo,
        itemLimit: row.itemLimit == null ? 0 : Number(row.itemLimit),
        durationSec: row.durationSec == null ? 0 : Number(row.durationSec),
        status: row.status
      }
      this.slots = this.parseSlots(row.slotsJson)
      this.weights = this.parseWeights(row.moduleWeightsJson, row.examType)
      this.editVisible = true
    },
    save () {
      if (!this.slots.length) {
        this.$Message.error('请至少添加一类题')
        return
      }
      for (let i = 0; i < this.slots.length; i++) {
        let slot = this.slots[i]
        if (!slot.bank || !slot.skill || !slot.questionType) {
          this.$Message.error('第 ' + (i + 1) + ' 类题的题库、技能、题型都要填')
          return
        }
        if (this.form.examType === 'PLACEMENT' && slot.skill === 'Writing') {
          this.$Message.error('入门测不能包含写作')
          return
        }
        if (!slot.count || slot.count < 1) {
          this.$Message.error('第 ' + (i + 1) + ' 类题的出题数量至少为 1')
          return
        }
      }
      let payload = Object.assign({}, this.form, {
        itemLimit: Number(this.form.itemLimit) || 0,
        durationSec: Number(this.form.durationSec) || 0,
        slotsJson: JSON.stringify(this.slots),
        moduleWeightsJson: this.stringifyWeights()
      })
      this.$http.post('/mex/blueprints/save', payload).then(res => {
        if (res.status === 'ok') {
          this.$Message.success(this.form.id ? '已更新' : '已新建')
          this.editVisible = false
          this.search()
        } else {
          this.$Message.error(res.msg || '保存失败')
        }
      })
    },
    changeStatus (id, action) {
      this.$http.post('/mex/blueprints/' + action, { id: id }).then(res => {
        if (res.status === 'ok') {
          this.$Message.success('已更新')
          this.search()
        } else {
          this.$Message.error(res.msg || '操作失败')
        }
      })
    }
  }
}
</script>

<style lang="less">
@import './mex-search.less';

.mex-slot-hint {
  margin: 0 0 8px;
  color: #808695;
  line-height: 20px;
}

.mex-slot-card {
  background: #f8f8f9;
  border: 1px solid #e8eaec;
  border-radius: 4px;
  padding: 8px 12px 0;
  margin-bottom: 10px;

  .mex-slot-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 4px;
    font-weight: 600;
  }

  .ivu-form-item {
    margin-bottom: 10px;
  }

  .ivu-form-item-label {
    padding: 0 0 4px;
    line-height: 18px;
    float: none;
  }

  .ivu-form-item-content {
    margin-left: 0 !important;
  }

  .ivu-select,
  .ivu-input-number {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// MexBlueprintList.vue?c7318d5e